import ButtonLike from "../../minicomponents/Button-like";
import Button from "../../minicomponents/Button";
import { useState, useEffect } from "react";
import { useUser } from "../../context/Usercontext";

let CardTweet = function ({
  buttonLikedSource,
  buttonUnlikedSource,
  post,
  navigate,
}) {
  let [liked, setLiked] = useState(false);

  let {
    handleLikePost,
    userObject,
    likedPosts,
    loadingLikes,
    deleteLikePost,
    changer,
    setLoadingLikes,
    fetchedLikes,
    lastLikeDeleted,
    setLikedPosts,
    updateLikePost,
    voteUpdating,
    currValueLiked,
  } = useUser();

  return (
    <div className="single-card-tweet">
      <span className="single-card-tweet-title">Post new</span>
      <span className="single-card-tweet-content">{post.fact_content}</span>
      <div className="single-card-tweet-buttons-area">
        <ButtonLike
          buttonLikedSource={buttonLikedSource}
          buttonUnlikedSource={buttonUnlikedSource}
          handleLikePost={handleLikePost}
          userObject={userObject}
          postId={post.id}
          postLike={post.like}
          likedPosts={likedPosts}
          loadingLikes={loadingLikes}
          deleteLikePost={deleteLikePost}
          changer={changer}
          setLoadingLikes={setLoadingLikes}
          navigate={navigate}
          fetchedLikes={fetchedLikes}
          lastLikeDeleted={lastLikeDeleted}
          setLikedPosts={setLikedPosts}
          updateLikePost={updateLikePost}
          voteUpdating={voteUpdating}
          currValueLiked={currValueLiked}
        />
        <Button buttonStyle={"button-app button-like"}>
          <img src="https://img.icons8.com/metro/22/null/topic.png" />
        </Button>
      </div>
    </div>
  );
};

export default CardTweet;
